const pino = require('pino');

const logger = (defaults) =>
  pino({
    ...defaults,
    timestamp: pino.stdTimeFunctions.isoTime,
    redact: ['pid', 'hostname'],
    base: undefined,
    messageKey: 'message',
    formatters:
      process.env.PINO_FORMATTER === 'none'
        ? {}
        : {
            level(label) {
              return { level: label.toUpperCase() };
            },
          },
    serializers: {
      error: (e) => ({
        type: e.constructor.name,
        message: e.message,
        stack: e.stack,
      }),
    },
  });

module.exports = { logger };
